export default "__VITE_ASSET__CuFUnCKZ__"